/**
 * 設定ダイアログ機能
 */

window.showConfigDialog = {
  // ダイアログを閉じる共通関数
  close: function(dialogId) {
    const dialog = document.getElementById(dialogId);
    if (dialog) {
      dialog.remove();
    }
  },
  
  // ============================================
  // サイドナビ更新ヘルパー関数
  // ============================================
  
  /**
   * サイドナビの用紙表示を更新
   * @param {string} paper - 用紙名
   */
  updateSideNavPaper: function(paper) {
    if (!paper) return;
    
    // 複数の可能性のあるID/セレクタを試す
    // price-calculator-init.jsで使用されるID
    const paperCurrentValue = document.getElementById('paper-current-value');
    if (paperCurrentValue) {
      paperCurrentValue.classList.remove('skeleton-loading');
      paperCurrentValue.textContent = paper;
    }
    
    // 古いテンプレートで使用される可能性のあるID
    const paperDisplay = document.getElementById('paper-display');
    if (paperDisplay) {
      paperDisplay.textContent = paper;
    }
    
    // paper-config-btnのnav-valueを更新（古いテンプレート用）
    const paperConfigBtn = document.getElementById('paper-config-btn');
    if (paperConfigBtn) {
      const navValue = paperConfigBtn.querySelector('.nav-value');
      if (navValue) {
        navValue.textContent = paper;
      }
    }
    
    // カート用hidden inputを更新
    const cartPaper = document.getElementById('cart-paper');
    if (cartPaper) {
      cartPaper.value = paper;
    }
  },
  
  /**
   * サイドナビの印刷色数表示を更新
   * @param {string} printColor - 印刷色数
   */
  updateSideNavPrintColor: function(printColor) {
    if (!printColor) return;
    
    // 複数の可能性のあるID/セレクタを試す
    // price-calculator-init.jsで使用されるID
    const printColorCurrentValue = document.getElementById('print-color-current-value');
    if (printColorCurrentValue) {
      printColorCurrentValue.classList.remove('skeleton-loading');
      printColorCurrentValue.textContent = printColor;
    }
    
    // 古いテンプレートで使用される可能性のあるID
    const printColorDisplay = document.getElementById('print-color-display');
    if (printColorDisplay) {
      printColorDisplay.textContent = printColor;
    }
    
    // print-color-config-btnのnav-valueを更新（古いテンプレート用）
    const printColorConfigBtn = document.getElementById('print-color-config-btn');
    if (printColorConfigBtn) {
      const navValue = printColorConfigBtn.querySelector('.nav-value');
      if (navValue) {
        navValue.textContent = printColor;
      }
    }
    
    // カート用hidden inputを更新
    const cartPrintType = document.getElementById('cart-print-type');
    if (cartPrintType) {
      cartPrintType.value = printColor;
    }
  },
  
  /**
   * 指定した印刷色数に直接変更する（ダイアログなし）
   * @param {string} printColor - 印刷色数
   */
  selectPrintColorDirectly: function(printColor) {
    if (!printColor) return;
    
    // price-calculator-init.jsのselectPrintColor関数が存在すればそれを使う
    // これにより一貫したUI更新が保証される
    if (typeof window.selectPrintColor === 'function') {
      window.selectPrintColor(printColor);
      return;
    }
    
    // fallback: 直接更新
    if (!window.priceCalculator) {
      console.warn('[ConfigDialogs] priceCalculator not available');
      return;
    }
    
    // 価格計算機の選択状態を更新
    window.priceCalculator.updateSelection({ printColor: printColor });
    
    // サイドナビを更新
    this.updateSideNavPrintColor(printColor);
    
    // ヘッダーを更新
    if (typeof window.updateGoodsHeader === 'function') {
      window.updateGoodsHeader();
    }
    
    // 印刷色数に応じたカラー選択オプションの表示/非表示を更新
    if (window.productOptionsManager && typeof window.productOptionsManager.updateColorOptionVisibility === 'function') {
      window.productOptionsManager.updateColorOptionVisibility(printColor);
    }
    
    // UIを全体的に更新
    if (typeof window.updateUI === 'function') {
      window.updateUI();
    }
  },
  
  // サイズ選択ダイアログ（PriceCalculator.Modal.openを使用した統一UI）
  size: function() {
    // まずAPIからサイズデータを取得してから表示
    const showSizeDialog = (availableSizes) => {
      this._showSizeDialogWithData(availableSizes);
    };

    // 現在のサイズ（Liquidから）を取得
    const currentSizeFromLiquid = window.productGroupInfo?.currentSize;

    // サイズオプションを構築（全てのサイズを寸法付き形式に変換）
    const buildSizeOptions = (sizeOptions) => {
      // formatSizeDisplay が利用可能な場合は使用
      const formatFn = window.formatSizeDisplay || ((s) => s);
      return sizeOptions.map(opt => {
        // 現在の商品の場合、Liquidの値を優先（APIキャッシュ対策）
        if (opt.isCurrent && currentSizeFromLiquid) {
          return formatFn(currentSizeFromLiquid);
        }
        return formatFn(opt.size);
      });
    };

    // window.sizeOptionsが既にある場合は即座に表示
    if (window.sizeOptions && window.sizeOptions.length > 0) {
      const availableSizes = buildSizeOptions(window.sizeOptions);
      showSizeDialog(availableSizes);
      return;
    }

    // sizeOptionsがない場合、loadProductGroupSizesを実行して待機
    if (typeof loadProductGroupSizes === 'function' && window.productGroupInfo) {
      loadProductGroupSizes().then(() => {
        if (window.sizeOptions && window.sizeOptions.length > 0) {
          const availableSizes = buildSizeOptions(window.sizeOptions);
          showSizeDialog(availableSizes);
        } else {
          // フォールバック
          this._showSizeDialogFallback();
        }
      }).catch((err) => {
        console.error('[Config Dialog] Error loading sizes:', err);
        this._showSizeDialogFallback();
      });
      return;
    }

    // loadProductGroupSizesが利用できない場合はフォールバック
    this._showSizeDialogFallback();
  },

  // フォールバック用サイズダイアログ表示
  _showSizeDialogFallback: function() {
    let availableSizes = [];

    // 1. 商品グループの商品リストからサイズを抽出
    if (window.productGroupProducts && window.productGroupProducts.length > 0) {
      const sizesFromGroup = [...new Set(window.productGroupProducts
        .map(p => p.size)
        .filter(s => s && s.length > 0)
      )];
      if (sizesFromGroup.length > 0) {
        availableSizes = sizesFromGroup;
      }
    }

    // 2. printTypeOptionsからサイズを抽出
    if (availableSizes.length === 0 && window.printTypeOptions && window.printTypeOptions.length > 0) {
      const sizesFromPrintType = [...new Set(window.printTypeOptions
        .map(p => p.size)
        .filter(s => s && s.length > 0)
      )];
      if (sizesFromPrintType.length > 0) {
        availableSizes = sizesFromPrintType;
      }
    }

    // 3. productGroupInfo.availableSizes（メタフィールドから）
    if (availableSizes.length === 0 && window.productGroupInfo && window.productGroupInfo.availableSizes && window.productGroupInfo.availableSizes.length > 0) {
      availableSizes = window.productGroupInfo.availableSizes;
    }

    // 4. pricingConfigDataから取得
    if (availableSizes.length === 0 && window.pricingConfigData && window.pricingConfigData.size_options && window.pricingConfigData.size_options.enabled) {
      const sizeOptions = window.pricingConfigData.size_options.sizes || [];
      availableSizes = sizeOptions.map(s => typeof s === 'string' ? s : s.value || s.label);
    }

    this._showSizeDialogWithData(availableSizes);
  },

  // サイズダイアログを実際に表示
  _showSizeDialogWithData: function(availableSizes) {

    // 5. サイズデータがない場合はエラーログを出力
    if (availableSizes.length === 0) {
      console.error('[Config Dialog] No size data available from any source:', {
        productGroupInfo: window.productGroupInfo,
        productGroupProducts: window.productGroupProducts,
        printTypeOptions: window.printTypeOptions,
        pricingConfigData: window.pricingConfigData
      });
      return;
    }

    // 現在のサイズ（Liquidの値を優先）
    const currentSize = window.productGroupInfo?.currentSize
      || (window.priceCalculator ? window.priceCalculator.currentSelection.size : null)
      || (availableSizes[0] || 'A3');

    // formatSizeDisplay が利用可能な場合は使用
    const formatFn = window.formatSizeDisplay || ((s) => s);

    // チラシ系商品かどうかを判定
    const isFlyer = window.shouldShowSizeDimensions
      ? window.shouldShowSizeDimensions(window.productGroupInfo?.groupName)
      : false;

    // サイズラベルを作成
    // チラシ系: 「A4（210×297mm）」形式
    // それ以外: 「A4」形式（そのまま）
    const sizeLabels = availableSizes.map(s => formatFn(s));
    const currentSizeLabel = formatFn(currentSize);

    // PriceCalculator.Modal.openを使用して統一UIで表示
    if (window.PriceCalculator && window.PriceCalculator.Modal) {
      window.PriceCalculator.Modal.open('商品サイズ', sizeLabels, currentSizeLabel, (selectedLabel) => {
        // ラベルから元のサイズ値を取得
        const selectedSize = selectedLabel.replace(/サイズ$/, '');
        this.applySizeDirectly(selectedSize);
      });
    } else {
      console.error('[Config Dialog] PriceCalculator.Modal is not available');
    }
  },

  // サイズを直接適用（統一モーダルからのコールバック用）
  applySizeDirectly: function(selectedSize) {
    if (!selectedSize) return;

    const currentHandle = window.productGroupInfo?.currentHandle || window.location.pathname.split('/products/')[1]?.split('?')[0];

    // 商品グループのサイズオプションを取得して、対応する商品ページに遷移
    if (typeof loadProductGroupSizes === 'function' && window.productGroupInfo) {

      loadProductGroupSizes().then(() => {
        // loadProductGroupSizes内で取得したsizeOptionsを直接使用
        const sizeOptions = window.sizeOptions || [];

        // 選択されたサイズに対応するオプションを探す
        const matchingOption = sizeOptions.find(opt => opt.size === selectedSize);

        if (matchingOption) {
          if (matchingOption.handle !== currentHandle) {
            // 現在の選択状態を URL パラメータに保存
            const params = new URLSearchParams();
            if (window.priceCalculator) {
              const selection = window.priceCalculator.currentSelection;
              if (selection.paper) params.set('paper', selection.paper);
              if (selection.printColor) params.set('printColor', selection.printColor);
              if (selection.quantity) params.set('quantity', selection.quantity);
              if (selection.delivery) params.set('delivery', selection.delivery);
            }

            // 別商品ページに遷移
            const url = `/products/${matchingOption.handle}${params.toString() ? '?' + params.toString() : ''}`;
            window.location.href = url;
            return;
          }
        } else {
          // matchingOptionが見つからない場合は、relatedProductsから探す
          if (window.productGroupInfo.relatedProducts && window.productGroupInfo.relatedProducts[selectedSize]) {
            const targetHandle = window.productGroupInfo.relatedProducts[selectedSize];
            if (targetHandle !== currentHandle) {
              const params = new URLSearchParams();
              if (window.priceCalculator) {
                const selection = window.priceCalculator.currentSelection;
                if (selection.paper) params.set('paper', selection.paper);
                if (selection.printColor) params.set('printColor', selection.printColor);
                if (selection.quantity) params.set('quantity', selection.quantity);
                if (selection.delivery) params.set('delivery', selection.delivery);
              }
              const url = `/products/${targetHandle}${params.toString() ? '?' + params.toString() : ''}`;
              window.location.href = url;
              return;
            }
          } else {
            this.navigateToSizeProduct(selectedSize, currentHandle);
            return;
          }
        }

        // 同じ商品ページの場合は、サイズのみ更新
        if (window.priceCalculator) {
          window.priceCalculator.updateSelection({ size: selectedSize });
        }
        this.updateSizeDisplay(selectedSize);
      }).catch(err => {
        console.error('[ConfigDialogs] Error loading product group sizes:', err);
        // エラー時は直接検索を試みる
        this.navigateToSizeProduct(selectedSize, currentHandle);
      });
    } else {
      // loadProductGroupSizesが利用できない場合
      // まずrelatedProductsから探す
      if (window.productGroupInfo && window.productGroupInfo.relatedProducts && window.productGroupInfo.relatedProducts[selectedSize]) {
        const targetHandle = window.productGroupInfo.relatedProducts[selectedSize];
        if (targetHandle !== currentHandle) {
          const params = new URLSearchParams();
          if (window.priceCalculator) {
            const selection = window.priceCalculator.currentSelection;
            if (selection.paper) params.set('paper', selection.paper);
            if (selection.printColor) params.set('printColor', selection.printColor);
            if (selection.quantity) params.set('quantity', selection.quantity);
            if (selection.delivery) params.set('delivery', selection.delivery);
          }
          const url = `/products/${targetHandle}${params.toString() ? '?' + params.toString() : ''}`;
          window.location.href = url;
          return;
        }
      }
      // それでもダメなら直接商品を検索
      this.navigateToSizeProduct(selectedSize, currentHandle);
    }
  },
  
  // 印刷方法選択ダイアログ
  printMethod: function() {
    const methods = ['オンデマンド', 'オフセット'];
    
    // 現在の商品の印刷方法を取得（productGroupInfoから優先）
    let currentMethod = 'オンデマンド';
    if (window.productGroupInfo && window.productGroupInfo.currentPrintType) {
      currentMethod = window.productGroupInfo.currentPrintType;
    } else if (window.priceCalculator && window.priceCalculator.currentSelection) {
      currentMethod = window.priceCalculator.currentSelection.printMethod;
    }
    
    
    let html = `
      <div class="config-dialog-overlay" id="print-method-dialog" onclick="if(event.target === this) window.showConfigDialog.close('print-method-dialog')">
        <div class="config-dialog">
          <div class="config-dialog-header">
            <h3>🖨️ 印刷方法選択</h3>
            <button class="close-btn" onclick="window.showConfigDialog.close('print-method-dialog')">&times;</button>
          </div>
          <div class="config-dialog-content">
            <div class="paper-categories">
              ${methods.map(method => `
                <div class="paper-option">
                  <input type="radio" name="print-method-selection" value="${method}" id="print-method-${method}" ${method === currentMethod ? 'checked' : ''}>
                  <label for="print-method-${method}">
                    <strong>${method}</strong>
                  </label>
                </div>
              `).join('')}
            </div>
          </div>
          <div class="config-dialog-footer">
            <button class="cancel-btn" onclick="window.showConfigDialog.close('print-method-dialog')">キャンセル</button>
            <button class="select-btn" onclick="window.showConfigDialog.applyPrintMethod()">選択</button>
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', html);
  },
  
  // 用紙選択ダイアログ
  paper: function() {

    if (!window.productData || !window.productData.price_matrix) {
      console.error('[ConfigDialogs] Missing window.productData or price_matrix');
      alert('価格データが読み込まれていません。ページを再読み込みしてください。');
      return;
    }

    // Shopifyオプションから用紙リストを取得（優先）
    const shopifyOptions = window.productData.shopify_options || [];
    const paperOption = shopifyOptions.find(opt => opt.name === '用紙');
    let papers = [];

    if (paperOption && paperOption.values && paperOption.values.length > 0) {
      // Shopifyオプションの順序を使用（CSVインポート時の順序が保持される）
      papers = [...paperOption.values];
    } else {
      // フォールバック: variation_codeから抽出
      const variations = window.productData.price_matrix.variations || {};
      const variationCodes = Object.keys(variations);
      const papersSet = new Set();
      variationCodes.forEach(code => {
        const parts = code.split('_');
        if (parts.length >= 2) {
          papersSet.add(parts[0]);
        }
      });
      papers = Array.from(papersSet);
    }

    // 並び順マスタでソート（設定がある場合）
    const ValueOrder = window.PriceCalculator?.ValueOrder;
    if (ValueOrder && ValueOrder.isLoaded()) {
      papers = ValueOrder.sortValues(papers, '用紙');
    }

    const currentPaper = window.priceCalculator ? window.priceCalculator.currentSelection.paper : (papers[0] || '');
    
    
    let html = `
      <div class="config-dialog-overlay" id="paper-dialog" onclick="if(event.target === this) window.showConfigDialog.close('paper-dialog')">
        <div class="config-dialog">
          <div class="config-dialog-header">
            <h3>📄 印刷用紙選択</h3>
            <button class="close-btn" onclick="window.showConfigDialog.close('paper-dialog')">&times;</button>
          </div>
          <div class="config-dialog-content">
            <div class="paper-categories">
              ${papers.map(paper => `
                <div class="paper-option">
                  <input type="radio" name="paper-selection" value="${paper}" id="paper-${paper}" ${paper === currentPaper ? 'checked' : ''}>
                  <label for="paper-${paper}">${paper}</label>
                </div>
              `).join('')}
            </div>
          </div>
          <div class="config-dialog-footer">
            <button class="cancel-btn" onclick="window.showConfigDialog.close('paper-dialog')">キャンセル</button>
            <button class="select-btn" onclick="window.showConfigDialog.applyPaper()">選択</button>
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', html);
  },
  
  // 印刷色数選択ダイアログ
  printColor: function() {
    
    if (!window.productData || !window.productData.price_matrix) {
      console.error('[ConfigDialogs] Missing window.productData or price_matrix');
      alert('価格データが読み込まれていません。ページを再読み込みしてください。');
      return;
    }
    
    const currentPaper = window.priceCalculator ? window.priceCalculator.currentSelection.paper : 'コート90kg';
    
    // 【リファクタリング】正規化関数は新しいモジュールを使用
    const normalizeCode = window.normalizeString || ((code) => {
      if (!code) return code;
      return code
        .replace(/（/g, '(')
        .replace(/）/g, ')')
        .replace(/／/g, '/')
        .replace(/\s+/g, ' ')
        .trim();
    });
    
    // 利用可能なバリアント組み合わせから、選択された用紙に対応する印刷色数を取得
    let colors = [];
    const combinations = window.availableVariantCombinations || window.productData.availableVariantCombinations;
    
    if (combinations && combinations.byPaper && combinations.byPaper[currentPaper]) {
      // 全バリアントベースのマッピングを使用（全てのオプションが表示される）
      colors = combinations.byPaper[currentPaper];
    } else {
      // フォールバック: 全バリアントから直接抽出
      const allVariants = window.productData?.variants || [];
      const shopifyOptions = window.productData?.shopify_options || [];
      
      if (window.extractConditionsFromVariants && allVariants.length > 0) {
        const extracted = window.extractConditionsFromVariants(allVariants, shopifyOptions);
        colors = extracted.byPaper[currentPaper] || [];
      } else {
        // 最終フォールバック: variantPriceDataから抽出
        const priceData = window.productData?.price_matrix?.price_data || [];
        const uniqueVariationCodes = [...new Set(priceData.map(p => p.variation_code))];
        const colorsSet = new Set();
        
        uniqueVariationCodes.forEach(code => {
          if (!code || code === '標準') return;
          const parts = code.split('_');
          if (parts.length >= 2 && (parts[0] === currentPaper || normalizeCode(parts[0]) === normalizeCode(currentPaper))) {
            colorsSet.add(parts.slice(1).join('_'));
          }
        });
        colors = Array.from(colorsSet);
      }
    }
    
    // Shopifyオプションの順序を参照してソート
    const shopifyColorOptions = window.productData.shopify_options?.find(opt => opt.name === '印刷色数')?.values || [];
    if (shopifyColorOptions.length > 0) {
      // 正規化マップを作成
      const normalizedShopifyOptions = shopifyColorOptions.map(opt => ({
        original: opt,
        normalized: normalizeCode(opt)
      }));
      
      colors.sort((a, b) => {
        const normalizedA = normalizeCode(a);
        const normalizedB = normalizeCode(b);
        
        const indexA = normalizedShopifyOptions.findIndex(opt => normalizeCode(opt.original) === normalizedA);
        const indexB = normalizedShopifyOptions.findIndex(opt => normalizeCode(opt.original) === normalizedB);
        
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });
      
      // variationsから取得した色をShopifyオプション値に置き換え（正規化マッチ）
      colors = colors.map(color => {
        const normalizedColor = normalizeCode(color);
        const matchingOption = normalizedShopifyOptions.find(opt => normalizeCode(opt.original) === normalizedColor);
        return matchingOption ? matchingOption.original : color;
      });
    }
    
    let currentColor = window.priceCalculator ? window.priceCalculator.currentSelection.printColor : '片面１色';
    
    if (!colors.includes(currentColor) && colors.length > 0) {
      currentColor = colors[0];
    }
    
    
    let html = `
      <div class="config-dialog-overlay" id="print-color-dialog" onclick="if(event.target === this) window.showConfigDialog.close('print-color-dialog')">
        <div class="config-dialog">
          <div class="config-dialog-header">
            <h3>🎨 印刷色数選択</h3>
            <button class="close-btn" onclick="window.showConfigDialog.close('print-color-dialog')">&times;</button>
          </div>
          <div class="config-dialog-content">
            <div class="print-categories">
              ${colors.map(color => `
                <div class="print-option">
                  <input type="radio" name="print-color-selection" value="${color}" id="print-color-${color}" ${color === currentColor ? 'checked' : ''}>
                  <label for="print-color-${color}">${color}</label>
                </div>
              `).join('')}
            </div>
          </div>
          <div class="config-dialog-footer">
            <button class="cancel-btn" onclick="window.showConfigDialog.close('print-color-dialog')">キャンセル</button>
            <button class="select-btn" onclick="window.showConfigDialog.applyPrintColor()">選択</button>
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', html);
  },
  
  // 加工オプション選択ダイアログ
  processing: function() {
    let html = `
      <div class="config-dialog-overlay" id="processing-dialog" onclick="if(event.target === this) window.showConfigDialog.close('processing-dialog')">
        <div class="config-dialog">
          <div class="config-dialog-header">
            <h3>✂️ 加工・オプション選択</h3>
            <button class="close-btn" onclick="window.showConfigDialog.close('processing-dialog')">&times;</button>
          </div>
          <div class="config-dialog-content">
            <p>必要な加工・オプションを選択してください。</p>
            <div class="processing-options">
              <div class="processing-group">
                <div class="processing-group-header">
                  <span class="processing-group-title">折り加工</span>
                </div>
                <div class="processing-group-content">
                  <div class="processing-checkbox">
                    <input type="checkbox" id="processing-folding" value="folding">
                    <label for="processing-folding">折り加工を追加</label>
                  </div>
                </div>
              </div>
              <div class="processing-group">
                <div class="processing-group-header">
                  <span class="processing-group-title">ラミネート加工</span>
                </div>
                <div class="processing-group-content">
                  <div class="processing-checkbox">
                    <input type="checkbox" id="processing-laminate" value="laminate">
                    <label for="processing-laminate">ラミネート加工を追加</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="config-dialog-footer">
            <button class="cancel-btn" onclick="window.showConfigDialog.close('processing-dialog')">キャンセル</button>
            <button class="select-btn" onclick="window.showConfigDialog.applyProcessing()">選択</button>
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', html);
  },
  
  // 入稿データ種類選択ダイアログ
  dataType: function() {
    const dataTypes = ['ワード', 'エクセル', 'PDF', 'Illustrator', 'Photoshop'];
    const currentType = window.priceCalculator ? window.priceCalculator.currentSelection.dataType : 'ワード';
    
    let html = `
      <div class="config-dialog-overlay" id="data-type-dialog" onclick="if(event.target === this) window.showConfigDialog.close('data-type-dialog')">
        <div class="config-dialog">
          <div class="config-dialog-header">
            <h3>📁 入稿データの種類選択</h3>
            <button class="close-btn" onclick="window.showConfigDialog.close('data-type-dialog')">&times;</button>
          </div>
          <div class="config-dialog-content">
            <div class="data-type-grid">
              ${dataTypes.map(type => `
                <div class="data-type-option">
                  <input type="radio" name="data-type-selection" value="${type}" id="data-type-${type}" ${type === currentType ? 'checked' : ''}>
                  <label for="data-type-${type}">
                    <div class="data-type-name">${type}</div>
                  </label>
                </div>
              `).join('')}
            </div>
          </div>
          <div class="config-dialog-footer">
            <button class="cancel-btn" onclick="window.showConfigDialog.close('data-type-dialog')">キャンセル</button>
            <button class="select-btn" onclick="window.showConfigDialog.applyDataType()">選択</button>
          </div>
        </div>
      </div>
    `;
    
    document.body.insertAdjacentHTML('beforeend', html);
  },
  
  // 各ダイアログの適用関数
  // 旧UIからの互換性のためのapplySize（ラジオボタンベース）
  applySize: function() {
    const selected = document.querySelector('input[name="size-selection"]:checked');
    if (!selected) {
      this.close('size-dialog');
      return;
    }

    const selectedSize = selected.value;
    this.close('size-dialog');
    this.applySizeDirectly(selectedSize);
  },
  
  // サイズ表示を更新するヘルパー関数
  updateSizeDisplay: function(size) {
    // サイズ表示を更新（複数の可能性のある要素を更新）
    const sizeDisplay = document.getElementById('size-display');
    if (sizeDisplay) {
      sizeDisplay.textContent = size;
    }
    
    // nav-valueクラスの要素も更新
    const sizeBtn = document.getElementById('size-config-btn');
    if (sizeBtn) {
      const navValue = sizeBtn.querySelector('.nav-value');
      if (navValue) {
        navValue.textContent = size;
      }
    }
    
    // product-size-current-valueも更新
    const productSizeValue = document.getElementById('product-size-current-value');
    if (productSizeValue) {
      productSizeValue.textContent = size;
    }
    
      if (typeof window.updateGoodsHeader === 'function') {
        window.updateGoodsHeader();
      }
  },
  
  // サイズに対応する商品ページに遷移するヘルパー関数
  navigateToSizeProduct: function(selectedSize, currentHandle) {

    if (!window.productGroupInfo || !window.productGroupInfo.groupName) {
      console.warn('[ConfigDialogs] Product group info not available, cannot navigate');
      // 商品グループ情報がない場合は、サイズのみ更新
      if (window.priceCalculator) {
        window.priceCalculator.updateSelection({ size: selectedSize });
      }
      this.updateSizeDisplay(selectedSize);
    this.close('size-dialog');
      return;
    }

    const groupName = window.productGroupInfo.groupName;
    const currentPrintType = window.productGroupInfo.currentPrintType;

    // サイズ値からベースサイズ（A4, B5など）を抽出（例: "A4（210×297mm）" → "A4"）
    const extractBaseSize = (size) => {
      const match = size.match(/^([AB]\d+)/i);
      return match ? match[1] : size;
    };

    // 商品を検索して、選択されたサイズに対応する商品のhandleを取得
    fetch(`/products.json?limit=250`)
      .then(response => response.json())
      .then(data => {
        const groupTag = `product_group:${groupName}`;
        
        // まず、グループタグでフィルタリング
        let products = (data.products || []).filter(product => {
          const tagsArray = Array.isArray(product.tags) 
            ? product.tags 
            : (typeof product.tags === 'string' ? product.tags.split(',').map(t => t.trim()) : []);
          
          // 完全一致を試す
          let hasGroupTag = tagsArray.some(tag => tag === groupTag);
          
          // 完全一致で見つからない場合、部分一致を試す
          if (!hasGroupTag) {
            hasGroupTag = tagsArray.some(tag => {
              if (tag.startsWith('product_group:')) {
                const tagValue = tag.substring('product_group:'.length);
                return tagValue === groupName || tagValue.includes(groupName) || groupName.includes(tagValue);
              }
              return false;
            });
          }
          
          return hasGroupTag;
        });
        
        
        // グループタグで見つからない場合、handleパターンで検索
        if (products.length === 0) {
          console.warn('[ConfigDialogs] No products found by tag:', groupTag);
          
          // 現在のhandleからサイズ部分を抽出して、新しいサイズに置き換える
          // 例: flyer-fsc-a3-offset -> flyer-fsc-a5-offset
          const sizePattern = /([ab])(\d+)/i; // A3, B5などのパターン
          const sizeMatch = currentHandle.match(sizePattern);
          
          if (sizeMatch) {
            const currentSizeStr = sizeMatch[0].toLowerCase(); // a3, b5
            // 選択されたサイズからベースサイズを抽出してhandle構築に使用
            const targetSizeStr = extractBaseSize(selectedSize).toLowerCase(); // a5, b5

            // handle内のサイズ部分を置き換える
            const targetHandle = currentHandle.replace(sizePattern, targetSizeStr);
            
            // 直接handleで検索
            const directMatch = (data.products || []).find(p => p.handle === targetHandle);
            if (directMatch) {
              products = [directMatch];
            } else {
              // 直接マッチしない場合、より柔軟なパターンで検索
              // flyer-fsc-* のようなパターンで検索
              const basePattern = currentHandle.replace(sizePattern, '').replace(/^-|-$/g, '');
              const prefixParts = basePattern.split('-').filter(p => p && !p.match(sizePattern));
              const prefix = prefixParts.join('-');
              
              products = (data.products || []).filter(product => {
                // プレフィックスが一致し、handleにサイズが含まれる商品を探す
                return product.handle.includes(prefix) && 
                       product.handle.includes(targetSizeStr);
              });
              
            }
          } else {
            // サイズパターンが見つからない場合、元のロジックを使用
            const currentHandleParts = currentHandle.split('-');
            const baseHandle = currentHandleParts.slice(0, -1).join('-');
            
            products = (data.products || []).filter(product => {
              return product.handle.startsWith(baseHandle);
            });
          }
          
        }
        
        // サイズと印刷方法でフィルタリング
        const matchingProduct = products.find(product => {
          const tagsArray = Array.isArray(product.tags) 
            ? product.tags 
            : (typeof product.tags === 'string' ? product.tags.split(',').map(t => t.trim()) : []);
          
          const sizeTag = tagsArray.find(tag => tag.startsWith('size_display:'));
          const printTypeTag = tagsArray.find(tag => tag.startsWith('print_type:'));
          
          const productSize = sizeTag ? sizeTag.split(':')[1] : '';
          const productPrintType = printTypeTag ? printTypeTag.split(':')[1] : '';
          
          // handleからも印刷方法を推測
          let inferredPrintType = productPrintType;
          if (!inferredPrintType && currentPrintType) {
            if (product.handle.includes('ondemand')) {
              inferredPrintType = 'オンデマンド';
            } else if (product.handle.includes('offset')) {
              inferredPrintType = 'オフセット';
            }
          }
          
          
          // サイズが一致し、印刷方法も一致する商品を探す
          if (currentPrintType && inferredPrintType) {
            return productSize === selectedSize && inferredPrintType === currentPrintType;
          }
          
          return productSize === selectedSize;
        });
        
        if (matchingProduct) {
          
          if (matchingProduct.handle !== currentHandle) {
            // 現在の選択状態を URL パラメータに保存
            const params = new URLSearchParams();
            if (window.priceCalculator) {
              const selection = window.priceCalculator.currentSelection;
              if (selection.paper) params.set('paper', selection.paper);
              if (selection.printColor) params.set('printColor', selection.printColor);
              if (selection.quantity) params.set('quantity', selection.quantity);
              if (selection.delivery) params.set('delivery', selection.delivery);
            }
            
            const url = `/products/${matchingProduct.handle}${params.toString() ? '?' + params.toString() : ''}`;
            window.location.href = url;
            return;
          } else {
          }
        } else {
          console.warn('[ConfigDialogs] Matching product not found for size:', selectedSize);
          
          // 商品が見つからない場合、handleを直接構築して遷移を試みる
          const sizePattern = /([ab])(\d+)/i;
          const sizeMatch = currentHandle.match(sizePattern);
          
          if (sizeMatch) {
            // 選択されたサイズからベースサイズを抽出してhandle構築に使用
            const targetSizeStr = extractBaseSize(selectedSize).toLowerCase();
            const targetHandle = currentHandle.replace(sizePattern, targetSizeStr);
            
            // 現在の選択状態を URL パラメータに保存
            const params = new URLSearchParams();
            if (window.priceCalculator) {
              const selection = window.priceCalculator.currentSelection;
              if (selection.paper) params.set('paper', selection.paper);
              if (selection.printColor) params.set('printColor', selection.printColor);
              if (selection.quantity) params.set('quantity', selection.quantity);
              if (selection.delivery) params.set('delivery', selection.delivery);
            }
            
            const url = `/products/${targetHandle}${params.toString() ? '?' + params.toString() : ''}`;
            
            // 直接遷移を試みる（商品が存在しない場合は404になるが、試してみる）
            window.location.href = url;
            return;
          } else {
            // handleパターンが見つからない場合は、サイズのみ更新
            console.warn('[ConfigDialogs] Cannot construct handle, updating size only');
            if (window.priceCalculator) {
              window.priceCalculator.updateSelection({ size: selectedSize });
            }
            this.updateSizeDisplay(selectedSize);
            this.close('size-dialog');
            return;
          }
        }
        
        // 同じ商品ページの場合は、サイズのみ更新
        if (window.priceCalculator) {
          window.priceCalculator.updateSelection({ size: selectedSize });
        }
        this.updateSizeDisplay(selectedSize);
        this.close('size-dialog');
      })
      .catch(error => {
        console.error('[ConfigDialogs] Error searching for product:', error);
        // エラー時は、サイズのみ更新
        if (window.priceCalculator) {
          window.priceCalculator.updateSelection({ size: selectedSize });
        }
        this.updateSizeDisplay(selectedSize);
        this.close('size-dialog');
      });
  },
  
  applyPrintMethod: function() {
    const selected = document.querySelector('input[name="print-method-selection"]:checked');
    if (selected && window.priceCalculator) {
      
      const selectedPrintMethod = selected.value;
      const currentHandle = window.productGroupInfo?.currentHandle || window.location.pathname.split('/products/')[1]?.split('?')[0];
      
      // 商品グループの印刷方法オプションを取得して、対応する商品ページに遷移
      if (typeof loadProductGroupPrintTypes === 'function' && window.productGroupInfo) {
        
        loadProductGroupPrintTypes().then(() => {
          // loadProductGroupPrintTypes内で取得したprintTypeOptionsを直接使用
          const printTypeOptions = window.printTypeOptions || [];
          const products = window.productGroupProducts || [];
          
          
          // 選択された印刷方法に対応するオプションを探す
          const matchingOption = printTypeOptions.find(opt => opt.printType === selectedPrintMethod);
          
          if (matchingOption) {
            
            if (matchingOption.handle !== currentHandle) {
              // 現在の選択状態を URL パラメータに保存
              const params = new URLSearchParams();
              if (window.priceCalculator) {
                const selection = window.priceCalculator.currentSelection;
                if (selection.paper) params.set('paper', selection.paper);
                if (selection.printColor) params.set('printColor', selection.printColor);
                if (selection.quantity) params.set('quantity', selection.quantity);
                if (selection.delivery) params.set('delivery', selection.delivery);
              }
              
              // 別商品ページに遷移
              const url = `/products/${matchingOption.handle}${params.toString() ? '?' + params.toString() : ''}`;
              window.location.href = url;
              return; // 遷移するので、以降の処理は実行しない
            } else {
            }
          } else {
            console.warn('[ConfigDialogs] Matching option not found for print method:', selectedPrintMethod);
            
            // フォールバック: 商品リストから直接検索
            if (products.length > 0) {
              const currentSize = window.productGroupInfo.currentSize;
              const matchingProduct = products.find(product => {
                const tagsArray = Array.isArray(product.tags) 
                  ? product.tags 
                  : (typeof product.tags === 'string' ? product.tags.split(',').map(t => t.trim()) : []);
                
                const sizeTag = tagsArray.find(tag => tag.startsWith('size_display:'));
                const printTypeTag = tagsArray.find(tag => tag.startsWith('print_type:'));
                
                const productSize = sizeTag ? sizeTag.split(':')[1] : '';
                const productPrintType = printTypeTag ? printTypeTag.split(':')[1] : '';
                
                const matchesSize = currentSize ? (productSize === currentSize || !productSize) : true;
                const matchesPrintType = productPrintType === selectedPrintMethod;
                
                
                if (currentSize && productSize) {
                  return productSize === currentSize && matchesPrintType;
                }
                
                return matchesPrintType;
              });
              
              if (matchingProduct) {
                
                if (matchingProduct.handle !== currentHandle) {
                  const params = new URLSearchParams();
                  if (window.priceCalculator) {
                    const selection = window.priceCalculator.currentSelection;
                    if (selection.paper) params.set('paper', selection.paper);
                    if (selection.printColor) params.set('printColor', selection.printColor);
                    if (selection.quantity) params.set('quantity', selection.quantity);
                    if (selection.delivery) params.set('delivery', selection.delivery);
                  }
                  
                  const url = `/products/${matchingProduct.handle}${params.toString() ? '?' + params.toString() : ''}`;
                  window.location.href = url;
                  return;
                }
              }
            } else {
              // 商品リストが空の場合は、直接商品を検索
              this.navigateToPrintTypeProduct(selectedPrintMethod, currentHandle);
              return;
            }
          }
          
          // 商品が見つからない、または同じ商品の場合は、選択だけを更新
          window.priceCalculator.updateSelection({ printMethod: selectedPrintMethod });
          
          // 印刷方法表示を更新
          const printMethodDisplay = document.getElementById('print-method-display');
          if (printMethodDisplay) {
            printMethodDisplay.textContent = selectedPrintMethod;
          }
          
          const printTypeBtn = document.getElementById('product-print-type-select-btn');
          if (printTypeBtn) {
            const printTypeValueSpan = document.getElementById('product-print-type-current-value');
            if (printTypeValueSpan) {
              printTypeValueSpan.textContent = selectedPrintMethod;
            }
          }
          
          if (typeof window.updateUI === 'function') {
            window.updateUI();
          }
          
      if (typeof window.updateGoodsHeader === 'function') {
        window.updateGoodsHeader();
          }
        }).catch(err => {
          console.error('[ConfigDialogs] Error loading product group print types:', err);
          // エラーの場合も直接商品を検索
          this.navigateToPrintTypeProduct(selectedPrintMethod, currentHandle);
        });
      } else {
        // loadProductGroupPrintTypesが利用できない場合は、直接商品を検索
        this.navigateToPrintTypeProduct(selectedPrintMethod, currentHandle);
      }
    }
    this.close('print-method-dialog');
  },
  
  // 印刷方法に対応する商品ページに遷移するヘルパー関数
  navigateToPrintTypeProduct: function(printMethod, currentHandle) {
    
    if (!window.productGroupInfo || !window.productGroupInfo.groupName) {
      console.warn('[ConfigDialogs] Product group info not available, cannot navigate');
      return;
    }
    
    const groupName = window.productGroupInfo.groupName;
    const currentSize = window.productGroupInfo.currentSize;
    
    
    // 商品を検索して、選択された印刷方法に対応する商品のhandleを取得
    // limitを増やして、より多くの商品を取得
    fetch(`/products.json?limit=250`)
      .then(response => response.json())
      .then(data => {
        const groupTag = `product_group:${groupName}`;
        
        // まず、グループタグでフィルタリング
        let products = (data.products || []).filter(product => {
          const tagsArray = Array.isArray(product.tags) 
            ? product.tags 
            : (typeof product.tags === 'string' ? product.tags.split(',').map(t => t.trim()) : []);
          
          // 完全一致を試す
          let hasGroupTag = tagsArray.some(tag => tag === groupTag);
          
          // 完全一致で見つからない場合、部分一致を試す
          if (!hasGroupTag) {
            // product_group: で始まり、groupNameを含むタグを探す
            hasGroupTag = tagsArray.some(tag => {
              if (tag.startsWith('product_group:')) {
                const tagValue = tag.substring('product_group:'.length);
                // 完全一致または部分一致
                return tagValue === groupName || tagValue.includes(groupName) || groupName.includes(tagValue);
              }
              return false;
            });
          }
          
          return hasGroupTag;
        });
        
        
        // グループタグで見つからない場合、より詳細なログを出力
        if (products.length === 0) {
          console.warn('[ConfigDialogs] No products found by tag:', groupTag);
          
          // 全商品からproduct_groupタグを持つ商品を探してログ出力
          const productsWithGroupTag = (data.products || []).filter(product => {
            const tagsArray = Array.isArray(product.tags) 
              ? product.tags 
              : (typeof product.tags === 'string' ? product.tags.split(',').map(t => t.trim()) : []);
            return tagsArray.some(tag => tag.startsWith('product_group:'));
          });
          
          if (productsWithGroupTag.length > 0) {
          }
          
          // handleパターンは最後の手段として使用（タグベースの検索が優先）
          const currentHandleParts = currentHandle.split('-');
          const baseHandle = currentHandleParts.slice(0, -1).join('-');
          
          products = (data.products || []).filter(product => {
            return product.handle.startsWith(baseHandle);
          });
          
        }
        
        // 印刷方法とサイズでフィルタリング
        const matchingProduct = products.find(product => {
          const tagsArray = Array.isArray(product.tags) 
            ? product.tags 
            : (typeof product.tags === 'string' ? product.tags.split(',').map(t => t.trim()) : []);
          
          const sizeTag = tagsArray.find(tag => tag.startsWith('size_display:'));
          const printTypeTag = tagsArray.find(tag => tag.startsWith('print_type:'));
          
          const productSize = sizeTag ? sizeTag.split(':')[1] : '';
          const productPrintType = printTypeTag ? printTypeTag.split(':')[1] : '';
          
          // handleからも印刷方法を推測（例: flyer-fsc-a3-ondemand → オンデマンド）
          let inferredPrintType = productPrintType;
          if (!inferredPrintType) {
            if (product.handle.includes('ondemand')) {
              inferredPrintType = 'オンデマンド';
            } else if (product.handle.includes('offset')) {
              inferredPrintType = 'オフセット';
            }
          }
          
          
          // サイズが一致し、印刷方法が一致する商品を探す
          if (currentSize && productSize) {
            return productSize === currentSize && inferredPrintType === printMethod;
          }
          
          return inferredPrintType === printMethod;
        });
        
        if (matchingProduct) {
          
          if (matchingProduct.handle !== currentHandle) {
            // 現在の選択状態を URL パラメータに保存
            const params = new URLSearchParams();
            if (window.priceCalculator) {
              const selection = window.priceCalculator.currentSelection;
              if (selection.paper) params.set('paper', selection.paper);
              if (selection.printColor) params.set('printColor', selection.printColor);
              if (selection.quantity) params.set('quantity', selection.quantity);
              if (selection.delivery) params.set('delivery', selection.delivery);
            }
            
            // 別商品ページに遷移
            const url = `/products/${matchingProduct.handle}${params.toString() ? '?' + params.toString() : ''}`;
            window.location.href = url;
          } else {
          }
        } else {
          console.warn('[ConfigDialogs] Matching product not found for print method:', printMethod);
          
          // 最後の手段: handleを直接構築して遷移を試みる（タグベースの検索が失敗した場合のみ）
          console.warn('[ConfigDialogs] Tag-based search failed, falling back to handle construction');
          let targetHandle = null;
          if (printMethod === 'オンデマンド') {
            targetHandle = currentHandle.replace('offset', 'ondemand');
          } else if (printMethod === 'オフセット') {
            targetHandle = currentHandle.replace('ondemand', 'offset');
          }
          
          if (targetHandle && targetHandle !== currentHandle) {
            // 直接遷移を試みる（商品が存在するかどうかは遷移時に確認）
            const params = new URLSearchParams();
            if (window.priceCalculator) {
              const selection = window.priceCalculator.currentSelection;
              if (selection.paper) params.set('paper', selection.paper);
              if (selection.printColor) params.set('printColor', selection.printColor);
              if (selection.quantity) params.set('quantity', selection.quantity);
              if (selection.delivery) params.set('delivery', selection.delivery);
            }
            
            const url = `/products/${targetHandle}${params.toString() ? '?' + params.toString() : ''}`;
            window.location.href = url;
          }
        }
      })
      .catch(err => {
        console.error('[ConfigDialogs] Error fetching products:', err);
      });
  },
  
  applyPaper: function() {
    const selected = document.querySelector('input[name="paper-selection"]:checked');
    if (selected && window.priceCalculator) {
      const newPaper = selected.value;
      
      // 選択された用紙に対応する印刷色数が存在するかチェック
      const combinations = window.availableVariantCombinations || window.productData?.availableVariantCombinations;
      const currentPrintColor = window.priceCalculator.currentSelection.printColor;
      let newPrintColor = currentPrintColor;
      
      if (combinations && combinations.byPaper && combinations.byPaper[newPaper]) {
        const availablePrintColors = combinations.byPaper[newPaper];
        
        if (!availablePrintColors.includes(currentPrintColor)) {
          // 現在の印刷色数が利用不可の場合、最初の利用可能な印刷色数に変更
          if (availablePrintColors.length > 0) {
            newPrintColor = availablePrintColors[0];
          }
        }
      }
      
      // 用紙と印刷色数を同時に更新
      window.priceCalculator.updateSelection({ paper: newPaper, printColor: newPrintColor });
      
      // サイドナビを更新（ヘルパー関数を使用）
      this.updateSideNavPaper(newPaper);
      
      // 印刷色数が変更された場合、サイドナビも更新
      if (newPrintColor !== currentPrintColor) {
        this.updateSideNavPrintColor(newPrintColor);
      }
      
      if (typeof window.updateGoodsHeader === 'function') {
        window.updateGoodsHeader();
      }
    }
    this.close('paper-dialog');
  },
  
  applyPrintColor: function() {
    const selected = document.querySelector('input[name="print-color-selection"]:checked');
    if (selected && window.priceCalculator) {
      const newPrintColor = selected.value;
      window.priceCalculator.updateSelection({ printColor: newPrintColor });
      
      // サイドナビを更新（ヘルパー関数を使用）
      this.updateSideNavPrintColor(newPrintColor);
      
      if (typeof window.updateGoodsHeader === 'function') {
        window.updateGoodsHeader();
      }
      
      // 印刷色数に応じたカラー選択オプションの表示/非表示を更新
      if (window.productOptionsManager && typeof window.productOptionsManager.updateColorOptionVisibility === 'function') {
        window.productOptionsManager.updateColorOptionVisibility(newPrintColor);
      }
    }
    this.close('print-color-dialog');
  },
  
  applyProcessing: function() {
    this.close('processing-dialog');
  },
  
  applyDataType: function() {
    const selected = document.querySelector('input[name="data-type-selection"]:checked');
    if (selected && window.priceCalculator) {
      window.priceCalculator.updateSelection({ dataType: selected.value });
      document.getElementById('data-type-display').textContent = selected.value;
      if (typeof window.updateGoodsHeader === 'function') {
        window.updateGoodsHeader();
      }
    }
    this.close('data-type-dialog');
  }
};

// イベントリスナーの初期化（即座に実行、DOMContentLoadedを待たない）
if (!window.dialogListenersInitialized) {
  window.dialogListenersInitialized = true;
  
  // イベント委譲を使用して、後から追加されるボタンにも対応
  // DOMContentLoadedを待たずに、即座に設定
  document.addEventListener('click', (e) => {
    // 商品サイズ選択ボタン（product-group-handler用）
    if (e.target.closest('#product-size-select-btn') || e.target.id === 'product-size-select-btn' || e.target.closest('button[id="product-size-select-btn"]')) {
      e.preventDefault();
      e.stopPropagation();
      
      // product-group-handlerの処理を実行
      const sizeBtn = document.getElementById('product-size-select-btn');
      if (sizeBtn) {
        // onclickが設定されている場合はそれを実行
        if (typeof sizeBtn.onclick === 'function') {
          sizeBtn.onclick(e);
        } else {
          // product-group-handlerが初期化されていない場合
          
          // まず、loadProductGroupSizesを試してみる
          if (typeof loadProductGroupSizes === 'function') {
            loadProductGroupSizes().then(() => {
              // 再試行
              if (typeof sizeBtn.onclick === 'function') {
                sizeBtn.onclick(e);
              } else {
                // それでもダメな場合は、サイズ選択ダイアログを開く
                window.showConfigDialog.size();
              }
            }).catch((err) => {
              console.error('[ConfigDialogs] Error loading product group sizes:', err);
              // エラーの場合もサイズ選択ダイアログを開く
              window.showConfigDialog.size();
            });
          } else {
            // loadProductGroupSizesが存在しない場合は、サイズ選択ダイアログを開く
            window.showConfigDialog.size();
          }
        }
      } else {
        console.error('[ConfigDialogs] product-size-select-btn not found');
      }
      return;
    }
    
    // サイズボタン（config-dialogs用）
    if (e.target.closest('#size-config-btn') || e.target.id === 'size-config-btn' || e.target.closest('.nav-button[id="size-config-btn"]')) {
      e.preventDefault();
      e.stopPropagation();
      window.showConfigDialog.size();
      return;
    }
    
    // 商品印刷方法選択ボタン（product-group-handler用）
    if (e.target.closest('#product-print-type-select-btn') || e.target.id === 'product-print-type-select-btn' || e.target.closest('button[id="product-print-type-select-btn"]')) {
      e.preventDefault();
      e.stopPropagation();

      // product-group-handlerの処理を実行
      const printTypeBtn = document.getElementById('product-print-type-select-btn');
      if (printTypeBtn) {
        // 無効化されている場合は何もしない（選択肢が1つしかない場合）
        if (printTypeBtn.getAttribute('data-disabled') === 'true') {
          return;
        }
        // onclickが設定されている場合はそれを実行
        if (typeof printTypeBtn.onclick === 'function') {
          printTypeBtn.onclick(e);
        } else {
          // product-group-handlerが初期化されていない場合
          
          // まず、loadProductGroupPrintTypesを試してみる
          if (typeof loadProductGroupPrintTypes === 'function') {
            loadProductGroupPrintTypes().then(() => {
              // 再試行
              if (typeof printTypeBtn.onclick === 'function') {
                printTypeBtn.onclick(e);
              } else {
                // それでもダメな場合は、印刷方法選択ダイアログを開く
                window.showConfigDialog.printMethod();
              }
            }).catch((err) => {
              console.error('[ConfigDialogs] Error loading product group print types:', err);
              // エラーの場合も印刷方法選択ダイアログを開く
              window.showConfigDialog.printMethod();
            });
          } else {
            // loadProductGroupPrintTypesが存在しない場合は、印刷方法選択ダイアログを開く
            window.showConfigDialog.printMethod();
          }
        }
      } else {
        console.error('[ConfigDialogs] product-print-type-select-btn not found');
      }
      return;
    }
    
    // 印刷方法ボタン（config-dialogs用）
    if (e.target.closest('#print-method-config-btn') || e.target.id === 'print-method-config-btn' || e.target.closest('.nav-button[id="print-method-config-btn"]')) {
      e.preventDefault();
      e.stopPropagation();
      window.showConfigDialog.printMethod();
      return;
    }

    // 商品色タイプ選択ボタン（product-group-handler用）
    if (e.target.closest('#product-color-type-select-btn') || e.target.id === 'product-color-type-select-btn' || e.target.closest('button[id="product-color-type-select-btn"]')) {
      e.preventDefault();
      e.stopPropagation();

      // product-group-handlerの処理を実行
      const colorTypeBtn = document.getElementById('product-color-type-select-btn');
      if (colorTypeBtn) {
        // onclickが設定されている場合はそれを実行
        if (typeof colorTypeBtn.onclick === 'function') {
          colorTypeBtn.onclick(e);
        } else {
          // product-group-handlerが初期化されていない場合
          if (typeof loadProductGroupColorTypes === 'function') {
            loadProductGroupColorTypes().then(() => {
              // 再試行
              if (typeof colorTypeBtn.onclick === 'function') {
                colorTypeBtn.onclick(e);
              }
            }).catch((err) => {
              console.error('[ConfigDialogs] Error loading product group color types:', err);
            });
          }
        }
      } else {
        console.error('[ConfigDialogs] product-color-type-select-btn not found');
      }
      return;
    }

    // 用紙ボタン
    if (e.target.closest('#paper-config-btn') || e.target.id === 'paper-config-btn' || e.target.closest('.nav-button[id="paper-config-btn"]')) {
      e.preventDefault();
      e.stopPropagation();
      window.showConfigDialog.paper();
      return;
    }
    
    // 印刷色数ボタン
    if (e.target.closest('#print-color-config-btn') || e.target.id === 'print-color-config-btn' || e.target.closest('.nav-button[id="print-color-config-btn"]')) {
      e.preventDefault();
      e.stopPropagation();
      window.showConfigDialog.printColor();
      return;
    }
    
    // 加工ボタン
    if (e.target.closest('#processing-config-btn') || e.target.id === 'processing-config-btn' || e.target.closest('.nav-button[id="processing-config-btn"]')) {
      e.preventDefault();
      e.stopPropagation();
      window.showConfigDialog.processing();
      return;
    }
    
    // データタイプボタン
    if (e.target.closest('#data-type-config-btn') || e.target.id === 'data-type-config-btn' || e.target.closest('.nav-button[id="data-type-config-btn"]')) {
      e.preventDefault();
      e.stopPropagation();
      window.showConfigDialog.dataType();
      return;
    }
  });
  
  
  // DOMContentLoaded時にも既存のボタンを確認してログ出力
  document.addEventListener('DOMContentLoaded', function() {
    
    const sizeBtn = document.getElementById('size-config-btn');
    const printMethodBtn = document.getElementById('print-method-config-btn');
    const paperBtn = document.getElementById('paper-config-btn');
    const printBtn = document.getElementById('print-color-config-btn');
    const processingBtn = document.getElementById('processing-config-btn');
    const dataTypeBtn = document.getElementById('data-type-config-btn');
    
    
    // 既存のボタンにも直接イベントリスナーを追加（二重登録を防ぐため、既存のリスナーをチェック）
    if (sizeBtn && !sizeBtn.hasAttribute('data-dialog-listener')) {
      sizeBtn.setAttribute('data-dialog-listener', 'true');
      sizeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.showConfigDialog.size();
      });
    }
    
    if (printMethodBtn && !printMethodBtn.hasAttribute('data-dialog-listener')) {
      printMethodBtn.setAttribute('data-dialog-listener', 'true');
      printMethodBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.showConfigDialog.printMethod();
      });
    }
    
    if (paperBtn && !paperBtn.hasAttribute('data-dialog-listener')) {
      paperBtn.setAttribute('data-dialog-listener', 'true');
      paperBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.showConfigDialog.paper();
      });
    }
    
    if (printBtn && !printBtn.hasAttribute('data-dialog-listener')) {
      printBtn.setAttribute('data-dialog-listener', 'true');
      printBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.showConfigDialog.printColor();
      });
    }
    
    if (processingBtn && !processingBtn.hasAttribute('data-dialog-listener')) {
      processingBtn.setAttribute('data-dialog-listener', 'true');
      processingBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.showConfigDialog.processing();
      });
    }
    
    if (dataTypeBtn && !dataTypeBtn.hasAttribute('data-dialog-listener')) {
      dataTypeBtn.setAttribute('data-dialog-listener', 'true');
      dataTypeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.showConfigDialog.dataType();
      });
    }
    
  });
}

